import type { CareerStat } from '@/modules/Career/Data/careerData';

interface CareerStatsProps {
  stats: CareerStat[];
}

export default function CareerStats({ stats }: CareerStatsProps) {
  return (
    <div className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div key={stat.label} className="rounded-xl border bg-white p-4 shadow-sm">
            <Icon className="mx-auto h-5 w-5 text-blue-600" />
            <div className="mt-2 text-2xl font-bold text-foreground">{stat.value}</div>
            <div className="text-xs text-muted-foreground">{stat.label}</div>
          </div>
        );
      })}
    </div>
  );
}
